export function LoadingSpinner() {
    return (
        <div className="flex min-h-screen items-center justify-center bg-zinc-950">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-zinc-700 border-t-blue-500" />
        </div>
    );
}
